import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Inconsolata%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22400%22,%22700%22],%22variable%22:%22--font-inconsolata%22}],%22variableName%22:%22inconsolata%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Inconsolata', 'Inconsolata Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
